import React from 'react';
import styled from 'styled-components';

import { TitleFull } from '@warehouse/title/core';
import { LabelValue } from '@warehouse/shared/ui';
import { timeToString } from '../../../components/library/DatePicker/DatePicker';

interface SystemSettingsTabProps {
	data?: TitleFull;
}

export function SystemSettingsTab({ data }: SystemSettingsTabProps) {
	const readonly = data?.readonly;

	return (
		<Grid>
			<LabelValue label="Edited At" value={formatDate(readonly?.editedAt)} />
			<LabelValue label="Edited By" value={readonly?.editedBy?.name || '--'} />
			<LabelValue label="Created At" value={formatDate(readonly?.createdAt)} />
			<LabelValue label="Created By" value={readonly?.createdBy?.name || '--'} />
		</Grid>
	);
}

function formatDate(date?: string) {
	if (!date) {
		return '--';
	}

	return timeToString(new Date(date));
}

const Grid = styled.div(
	({ theme }) => `
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.spacing(3)};
    width: calc(100% + ${theme.spacing(2)});
    margin-left: -${theme.spacing(1)};
    margin-top: -6px;

    .MuiTypography-root {
      color: ${theme.palette.text.primary}
    }
  `,
);
